import {Directive, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
    selector: '[normaliseRegistrationNumber]',
    standalone: false
})
export class NormaliseRegistrationNumberDirective
{
    constructor(private control: NgControl)
    {
    }

    @HostListener('blur')
    onBlur(): void
    {
        const value = this.control.control?.value;
        if (!value)
        {
            return;
        }
        const normalised = value.replace(/\s/g, '').toUpperCase();
        if (normalised !== value)
        {
            this.control.control?.setValue(normalised);
        }
    }
}
